/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.uploadReceipt.internal

import features.uploadReceipt.models.UploadReceiptResponseModel
import kangaroorewards.appsdk.core.io.toModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.krMultiPartForm.UploadReceiptRequestModel

internal class UploadReceiptServiceImpl : UploadReceiptService {

    private val uploadReceiptRequest = UploadReceiptRequest()

    override suspend fun uploadReceipt(
        overrideHeaders: Map<String, String>?,
        businessId: String,
        uploadReceiptBodyRequest: UploadReceiptRequestModel
    ): Result<UploadReceiptResponseModel> {
        return uploadReceiptRequest.uploadReceipt(
            overrideHeaders = overrideHeaders,
            businessId = businessId,
            uploadReceiptBodyRequest = uploadReceiptBodyRequest
        ).toModel()
    }
}